// extracted by mini-css-extract-plugin
export default {"control":"Control_control__064L0","button":"Control_button__M6CGz","approved":"Control_approved__Yioni","rejected":"Control_rejected__ZDtnC"};